import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { VisaApplicationForm } from './VisaApplicationForm';
import {
  type ApplicationVisaDetail,
  useGetApplicationVisaDetail,
} from '../../graphql';
import { useUpdateVisaApplication } from '../../../Application/graphql';
import {
  Alert,
  type AlertDetails,
  Accordion,
  Loading,
} from '../../../../components';

export const ARVisaApplicationDetail: React.FunctionComponent = () => {
  const { applicationId = '' } = useParams();
  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });

  const {
    applicationVisaDetail,
    error: errRequestId,
    loading,
  } = useGetApplicationVisaDetail({
    applicationId: {
      eq: applicationId,
    },
  });

  if (errRequestId) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (errRequestId as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  const updateVisaApplication = useUpdateVisaApplication();
  const handleOverWrite = async (
    value: ApplicationVisaDetail,
  ): Promise<void> => {
    const {
      referenceNo,
      immdOfficerInCharge,
      visaLabelApprovalDate,
      applicationReceivedDate,
      submissionDateToImmd,
      visaExpirationDate,
      status,
    } = value;

    try {
      const variables = {
        input: {
          applicationId,
          referenceNo,
          immdOfficerInCharge,
          visaLabelApprovalDate,
          applicationReceivedDate,
          submissionDateToImmd,
          visaExpirationDate,
          status,
        },
      };

      const res = await updateVisaApplication({
        variables,
      });
      if (res.data?.updateVisaApplication?.status !== undefined) {
        setAlertDetails({
          alertContent: `Updated Visa Information Successfully`,
          alertType: 'success',
        });
        setOpenAlert(true);
      }
    } catch (error: any) {
      if (error instanceof Error) {
        setAlertDetails({
          alertContent: `Updated Visa Information Failed.${error.message}`,
          alertType: 'error',
        });
        setOpenAlert(true);
      }
    }
  };

  return (
    <div className="w-full">
      {loading ? (
        <Loading />
      ) : (
        <Accordion
          title="Visa Application"
          defaultExpanded
          details={
            <>
              <VisaApplicationForm
                applicationVisaDetail={applicationVisaDetail}
                viewMode={false}
                handleOverWrite={handleOverWrite}
              />
              <Alert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alertDetails={alertDetails}
              />
            </>
          }
        />
      )}
    </div>
  );
};
